"use client";
import Link from "next/link";
import React from "react";

type ButtonProps = {
  label: string;
  className?: string;
  disabled?: boolean;
  href: string;
  color?: string;
  stroke?: string;
  onClick?: () => void;
};

const ButtonLink: React.FC<ButtonProps> = ({
  label,
  href,
  className = "",
  disabled = false,
  color,
  stroke,
  onClick,
}) => {
  const baseClasses =
    "w-fit flex items-center justify-center gap-2.5 text-subtitle-2 font-semibold transition-all duration-300 group";

  const textColor = color ? color : "text-primary-text-white";
  const strokeColor = stroke ? stroke : "stroke-primary-text-white";

  const enabledClasses = `${textColor} cursor-pointer hover:opacity-90`;
  const disabledClasses =
    "text-gray-300 cursor-not-allowed pointer-events-none";

  const combinedClasses = `${baseClasses} ${
    disabled ? disabledClasses : enabledClasses
  } ${className}`;

  return disabled ? (
    <span className={combinedClasses}>{label}</span>
  ) : (
    <Link href={href} className={combinedClasses} onClick={onClick}>
      {label}
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-[0_0_auto]"
      >
        <path
          d="M1.25 9.6582H17.75"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
          className={`group-hover:opacity-100 xl:opacity-0 opacity-100 transition-all duration-300 ${strokeColor}`}
        />
        <path
          d="M11.5908 2.5L18.7499 9.65909L11.5908 16.8181"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
          className={`group-hover:translate-x-0 xl:-translate-x-[3px] translate-x-0 transition-all duration-300 ${strokeColor}`}
        />
      </svg>
    </Link>
  );
};
export default ButtonLink;
